import { LinkTo } from "../LinkTo";
import "./Navigation.scss";

export function Navigation({ onClick }) {
	return (
		<ul className="navigation">
			<li>
				<LinkTo
					href={"/tech-radar"}
					className="navigation__link"
					activeClassName="navigation__link--active"
					onClick={onClick}>
					Tech Radar
				</LinkTo>
			</li>
			<li>
				<LinkTo
					href={"/score-breakdown"}
					className="navigation__link"
					activeClassName="navigation__link--active"
					onClick={onClick}>
					Score Breakdown
				</LinkTo>
			</li>
		</ul>
	);
}
